import { delData, getData, postData, patchData } from '../../../utils/fetch-api-util';
import { TourStoryType } from '../../../types/tourStory';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface TourStoryRequestParams {
  take?: number;
  page?: number;
  country?: string;
}

export interface TourStoryTypeResponse {
  tourStories: TourStoryType[];
  total: number;
}

export interface createTourStoryType {
  type: string;
  url: string;
  options: any;
  countries: string;
  sortOrder: number;
}

export interface deleteMultipleTourStoryType {
  ids: [];
}

interface SuccessResponse {
  success: boolean;
}

export interface SortTourStoriesPayload {
  sortOrderList: {
    id: string;
    sortOrder: number;
  }[];
}

export const getTourStoryListRepository = async (data?: TourStoryRequestParams): Promise<TourStoryTypeResponse> => {
  const response = await getData<TourStoryRequestParams, TourStoryTypeResponse>(API_URLS.TOUR_STORY_LIST, data);
  return response.data;
};

export const postCreateTourStoryRepository = async (payload: createTourStoryType): Promise<void> => {
  await postData<createTourStoryType, SuccessResponse>(API_URLS.TOUR_STORY_API, payload);
};

export const postDeleteMultipleTourStoryRepository = async (payload: deleteMultipleTourStoryType): Promise<void> => {
  await postData<deleteMultipleTourStoryType, SuccessResponse>(API_URLS.DELETE_MULTIPLE_TOUR_STORY, payload);
};

export const patchActiveTourStoryRepository = async (payload: { disabled: boolean; id: string }): Promise<void> => {
  await patchData<{ disabled: boolean }, SuccessResponse>(API_URLS.TOUR_STORY_ACTIVE_URL_WITH_ID(payload?.id || ''), {
    disabled: !!payload?.disabled,
  });
};

export const deleteTourStoryRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.TOUR_STORY_URL_WITH_ID(id));
};

export const postSortTourStoryRepository = async (payload: SortTourStoriesPayload): Promise<void> => {
  await postData<SortTourStoriesPayload, SuccessResponse>(API_URLS.TOUR_STORY_SORT, payload);
};
